<template>
  <v-toolbar :clipped-left="true" app fixed color="primary">
    <v-toolbar-title>
      <v-toolbar-side-icon class="nav-btn" @click.stop="miniNav = !miniNav"></v-toolbar-side-icon>
    </v-toolbar-title>
    <span class="plant-autocomplete" v-if="plantSelectionRequired && !widthBoolean"
      v-show="$route.name != 'notification'">
      <v-autocomplete class="mx-3 autocomplete" :background-color="$vuetify.theme.bg" :items="plantNameList"
        v-model="plantName" @change="plantChangeHandler" placeholder="Search Plant" solo-inverted flat dense hide-no-data hide-details hide-selected 
        :allow-overflow="false" :single-line="true">
      </v-autocomplete>
    </span>
    <v-spacer></v-spacer>
    <img v-if="computeLogoAddress" :src="computeLogoAddress" class="customer-logo" width="100"
      height="30" />
    <v-menu v-if="widthBoolean" left offset-y :close-on-content-click="false" class="menu">
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="iconColor" icon v-bind="attrs" v-on="on">
          <v-icon>mdi-chevron-double-down</v-icon>
        </v-btn>
      </template>
      <v-list class="addbg">
        <v-tooltip color="bg" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="changeTheme" class="ma-2 iconColor" v-bind="attrs" v-on="on">
              <v-icon>{{ goDark ? 'light_mode' : 'dark_mode' }}</v-icon>
            </v-btn>
          </template>
          <span class="tooltip-text__color">{{ $t("Theme") }}</span>
        </v-tooltip>
        <v-tooltip color="bg" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="toggleReload" class="ma-2 iconColor" v-bind="attrs" v-on="on">
              <v-icon :color="refreshButtonColor">refresh</v-icon>
            </v-btn>
          </template>
          <span class="tooltip-text__color">
            {{ $t("Auto-Refresh - Every") }} {{ getReloadTimeInMin }} {{ $t("Minute") }}
          </span>
          <br />
          <span class="tooltip-text__color">
            {{ $t("Last Updated") }}: {{ getGeneralState("lastCallTime") }}
          </span>
        </v-tooltip>
        <v-tooltip color="bg" bottom>
          <NotificationMenu slot="activator" :notifications="notifications" />
          <span class="tooltip-text__color">{{ $t("Notification") }}</span>
        </v-tooltip>
      </v-list>
    </v-menu>
    <v-tooltip color="bg" bottom v-if="!widthBoolean">
      <NotificationMenu slot="activator" :notifications="notifications" />
      <span class="tooltip-text__color">{{ $t("Notification") }}</span>
    </v-tooltip>
    <v-tooltip color="bg" bottom v-if="!widthBoolean">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon @click="changeTheme" class="ma-2 iconColor" v-bind="attrs" v-on="on">
          <v-icon>{{ goDark ? 'light_mode' : 'dark_mode' }}</v-icon>
        </v-btn>
      </template>
      <span class="tooltip-text__color">{{ $t("Theme") }}</span>
    </v-tooltip>
    <v-tooltip color="bg" bottom v-if="!widthBoolean">
      <v-btn class="iconColor"flat icon slot="activator" @click="toggleReload" @dblclick="instantRefresh">
        <v-icon :color="refreshButtonColor">refresh</v-icon>
      </v-btn>
      <span class="tooltip-text__color">{{ $t("Auto-Refresh - Every") }} {{ getReloadTimeInMin }} Minute</span><br />
      <span class="tooltip-text__color">{{ $t("Last Updated") }}: {{ getGeneralState("lastCallTime") }}</span><br />
      <span class="note">{{ $t("Single Click - Toggle Auto Reload") }}</span><br />
      <span class="note">{{ $t("Double Click - Instant Refresh") }}</span><br />
    </v-tooltip>
    <v-tooltip color="bg" bottom>
      <v-btn flat icon slot="activator" @click="toggleFullscreen" class="hidden-sm-and-down iconColor">
        <v-icon v-if="isFullscreen">fullscreen_exit</v-icon>
        <v-icon v-else>fullscreen</v-icon>
      </v-btn>
      <span class="tooltip-text__color">{{ $t("Fullscreen") }}</span>
    </v-tooltip>
    <v-tooltip color="bg" bottom>
      <LanguageSelectBox slot="activator" />
      <span class="tooltip-text__color">{{ $t("Select Language") }}</span>
    </v-tooltip>
    <div v-if="logoList.length > 0">
      <span v-for="(logo, index) in logoList" :key="index" class="logo-img-plant">
        <img :src="logo" />
      </span>
    </div>
    <div class="brand-logo">
      <img :src="goDark ? require('@/assets/sol light.svg') : require('@/assets/sol dark.svg')" />
      <span class="version-text">v{{ version }}</span>
    </div>
    <div class="d-flex align-center justify-center">
    </div>
  </v-toolbar>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import {
  version
} from '../../../../package.json'
import { setTheme } from '@/util/mixin/index.js';
import Notification from "@/services/Notification";
const NotificationMenu = () => import("@/components/NotificationMenu");
const LanguageSelectBox = () => import("@/components/common/LanguageSelectBox");

export default {
  components: {
    NotificationMenu,
    LanguageSelectBox,
  },
  mixins: [setTheme],
  data() {
    return {
      goDark: true,
      isFullscreen: false,
      plant1: "",
      isOpen: false,
      plantName: null,
      currentWidth: window.innerWidth,
      version,
      notifications: []
    };
  },
  computed: {
    ...mapGetters([
      "getPlantId",
      "getUserInfo",
      "getActivePlantInfo",
      "getGeneralState",
      "getReloadTimeInMin",
      "getPlantList",
      "getSelectedPlantId"
    ]),
    plantSelectionRequired() {
      return (
        this.$route.name !== "home" &&
        this.$route.name !== "thinkHome" &&
        this.$route.name !== "plantAnalytics"&&
        this.$route.name !== "inverterStatus"
      );
    },
    widthBoolean() {
      return this.currentWidth < 510;
    },
    logoList() {
      const logos = this.getUserInfo('logo') || '';
      if (!logos) {
        return []
      }

      const logoList = logos.split(',')
        .map(logo => logo.replace(/^\s+|\s+$/g, ''))
        .filter(logo => logo !== 'https://scada4x-assets.s3.ap-south-1.amazonaws.com/blank.svg')
        .slice(0, 2)
        .map(logo => {
          if (logo.includes('amazonaws.com') || logo.includes('scada4x-assets')) {
             const baseUrl = process.env.VUE_APP_BASE_URL || ("http://" + location.hostname + ":3030");
             const encodedUrl = encodeURIComponent(logo);
             return `${baseUrl}/api/v2/assets?url=${encodedUrl}`;
          }
          return logo;
        });
      
      return logoList
    },
    plantNameList() {
      return this.getPlantList.map((el) => el.name);
    },
    plantIdList() {
      return this.getPlantList.map((el) => el.id);
    },
    computeLogoAddress() {
      let image = this.getActivePlantInfo("logo");

      if (image == null) {
        return "";
      }

      // If the image is from AWS S3, use the backend proxy
      if (image.includes('amazonaws.com') || image.includes('scada4x-assets')) {
        const baseUrl = process.env.VUE_APP_BASE_URL || ("http://" + location.hostname + ":3030");
        const encodedUrl = encodeURIComponent(image);
        return `${baseUrl}/api/v2/assets?url=${encodedUrl}`;
      }

      return image;
    },
    refreshButtonColor() {
      let color = this.getGeneralState("autoReload") ? "" : "red";
      return color;
    },
    miniNav: {
      get() {
        return this.getGeneralState("miniNav");
      },
      set(value) {
        this.SET_MINI_NAV(value);
      },
    },
  },
  mounted() {
    this.plantName = this.getActivePlantInfo("plant_name")

    if (this.notifications.length <= 50) {
      const idCsv = this.plantIdList.join();
      const base64data = btoa(idCsv);
      this.SET_PROGRESS_BAR(true);
      Notification.fetchNotification(
        base64data,
        this.notifications.length,
        50
      )
        .then((res) => {
          this.notifications = res.data.message;
          this.SET_PROGRESS_BAR(false);
        })
        .catch((err) => {
          console.log(err);
          this.SET_PROGRESS_BAR(false);
        });
    }
    this.goDark = this.getGeneralState("theme_dark");

    this.getPlantList.map((el) => {
      this.$mqtt.subscribe(`/notification/${el.id}`);
    });
    this.$mqtt.on("message", (topic, message) => {
      if (topic.startsWith("/notification/")) {
        const parsedMessage = JSON.parse(message.toString());
        if (parsedMessage instanceof Array) {
          this.notifications = this.notifications.unshift(...parsedMessage);
        } else {
          this.$set(this.notifications, 0, parsedMessage);
        }
      }
    });

    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    this.getPlantList.map((el) => {
      this.$mqtt.unsubscribe(`/notification/${el.id}`);
    });
  },
  methods: {
    ...mapActions(["fetchActivePlantDetails"]),
    ...mapMutations([
      "SET_THEME",
      "SET_PROGRESS_BAR",
      "SET_MAP_REDIRECT_PLANT",
      "SET_AUTO_RELOAD",
      "SET_INSTANT_REFRESH",
      "SET_MINI_NAV",
    ]),
    handleResize() {
      this.currentWidth = window.innerWidth;
    },
    changeTheme: function () {
      this.goDark = !this.goDark;
      this.SET_THEME(this.goDark);
    },
    toggleReload() {
      this.SET_AUTO_RELOAD(!this.getGeneralState("autoReload"));
    },
    instantRefresh() {
      console.log("DOUBLE CLICKED");
      this.SET_INSTANT_REFRESH(!this.getGeneralState("instantRefresh"));
    },
    toggleFullscreen(event) {
      var elem = document.documentElement;
      if (
        document.fullscreenEnabled ||
        document.webkitFullscreenEnabled ||
        document.mozFullScreenEnabled ||
        document.msFullscreenEnabled
      ) {
        if (!this.isFullscreen) {
          if (elem.requestFullscreen) {
            elem.requestFullscreen();
            this.isFullscreen = true;
          } else if (elem.webkitRequestFullscreen) {
            elem.webkitRequestFullscreen();
            this.isFullscreen = true;
          } else if (elem.mozRequestFullScreen) {
            elem.mozRequestFullScreen();
            this.isFullscreen = true;
          } else if (elem.msRequestFullscreen) {
            elem.msRequestFullscreen();
            this.isFullscreen = true;
          }
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen();
            this.isFullscreen = false;
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
            this.isFullscreen = false;
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
            this.isFullscreen = false;
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
            this.isFullscreen = false;
          }
        }
      }
    },
    async plantChangeHandler() {
      if (this.plantSelectionRequired && !this.widthBoolean) {
        const plantId = this.getPlantId(this.plantName)[0];
        if (!plantId) {
          return;
        }

        await this.fetchActivePlantDetails(plantId)
        if (this.getGeneralState("mapRedirectPlant")) {
          this.SET_MAP_REDIRECT_PLANT(false);
        }
      }
    }
  },
  watch: {
    getSelectedPlantId() {
      this.plantName = this.getActivePlantInfo("plant_name")
    }
  }
};
</script>

<style scoped>
.iconColor {
  color: #BABABA !important;
}

.theme--light .iconColor {
  color: #333333 !important;
}

.theme--light .tooltip-text__color {
  color: #000;
}

.brand-logo img {
  height: 20px;
  width: 90px;
  margin-top: 4px;
}

.logo-img-plant img {
  height: 44px;
  width: 100px;
  margin-top: 8px;
  margin-right: 10px;
}

.customer-logo {
  width: 100px;
  height: 30px;
  margin: 0px 10px;
}

.version-text {
  font-size: 12px;
}

.plant-autocomplete {
    width: 400px;
  }

.note {
  color: #fbbc05;
}

.nav-btn {
  margin-left: -2px;
}

@media (max-width: 960px) {
  .ag-info-name {
    color: #04112f !important;
  }

  .logo-img-plant {
    display: none;
  }
}

@media(max-width:960px) and (min-width: 600px) {
  .nav-btn {
    margin-left: 10px;
  }
}

@media (max-width:510px) {
  .nav-btn {
    display: none;
  }
}

@media(max-width:795px) and (min-width: 510px) {
  .brand-logo {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .brand-logo img {
    margin-top: 0px !important;
  }

  .version-text {
    padding-top: 5px;
  }
}

@media(max-width:795px) and (min-width: 510px) {
  .plant-autocomplete {
    margin-left: 10px;
  }
}

.addbg {
  display: flex;
  align-items: center;
  background-color: #07225f;
}

.theme--light.addbg {
  background-color: white;
}
</style>

<style>
.autocomplete.v-select__selection,
.autocomplete.v-select__selection--comma,
.autocomplete.v-select.v-text-field input {
  color: var(--v-primaryText-base) !important;
}

.theme--dark .v-select-list>.v-list {
  background-color: #0f1e57;
  color: white;
}
</style>